import React, { useEffect, useState } from "react";
import { read } from "Helpers/LocalStorage";
import HomeService from "Services/http/endpoints/home/HomeService";
import StatusHandler from "Helpers/StatusHandler";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import { Pie } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";

export default function DoughnutUnitFrameRebuild({
  height = "300px",
  dataSearch = null,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: 8,
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            let sum = 0;
            let dataArr = context.dataset.data;
            dataArr.map((data) => (sum += data));
            return (
              ((context.raw * 100) / sum).toFixed(1) + "% - " + context.raw
            );
          },
        },
      },
      legend: {
        rtl: true,
        position: "right",
        labels: {
          font: {
            family: "IRANSans",
            size: 10,
          },
        },
      },
      title: {
        display: true,
        text: t("dunitsCount_renovationReconstructionFrame"),
        font: {
          family: "IRANSans",
          size: 12,
        },
      },
      datalabels: {
        color: "white",
        font: {
          weight: "bold",
          size: 8,
        },
        display: "auto",
        clip: true,
        textAlign: "center",
        formatter: (value, ctx) => {
          let sum = 0;
          let dataArr = ctx.chart.data.datasets[0].data;
          dataArr.map((data) => (sum += data));
          return ((value * 100) / sum).toFixed(1) + "%";
        },
      },
    },
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupAKey"),
          KeyUser: read("userAKey"),
          IsAdminP: true,
          ...dataSearch,
        };
        const response = await HomeService.getDoughnutUnitFrameRebuild(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          setData(response.data.Value);
        } else {
          setData(null);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, [dataSearch]);

  return (
    <MuiPaper className="mt-2">
      {loading ? (
        <InnerCircularProgress />
      ) : (
        <>
          {data && (
            <Pie
              data={data}
              options={options}
              type="pie"
              style={{ maxHeight: height }}
            />
          )}
        </>
      )}
    </MuiPaper>
  );
}
